
import { FileAttachment } from '../types';

export const readFileAsBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = error => reject(error);
  });
};

export const readFileContent = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => resolve(event.target?.result as string);
    reader.onerror = (error) => reject(error);
    reader.readAsText(file);
  });
};

export const processFileAttachment = async (file: File): Promise<FileAttachment> => {
  const data = await readFileAsBase64(file);
  let textContent = '';

  // Probeer tekst uit te lezen als het een leesbaar formaat is
  if (file.type.includes('text') || file.type.includes('csv') || file.type.includes('json') || file.type.includes('pdf')) {
    try {
      // Voorlopig behandelen we PDF's als tekst voor simpele extractie als ze tekstgebaseerd zijn
      // In een productie-omgeving zou hier een echte PDF parser (pdf.js) zitten.
      textContent = await readFileContent(file);
    } catch (e) {
      console.warn("Kon tekstinhoud niet uitlezen voor:", file.name);
    }
  }

  return {
    id: crypto.randomUUID(),
    name: file.name,
    type: file.type,
    size: file.size,
    data: data,
    textContent: textContent
  };
};

export const formatFileSize = (bytes: number) => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};
